import { useMemo } from "react";
import type { QueryKey } from "@tanstack/react-query";
import AssignDialog from "../components/AssignDialog";
import { useVisible } from "utils/hooks/useVisible";

interface UseAssignDialogProps {
    queryOptions: { queryKey: QueryKey };
    onSuccess?: () => void;
}

export const useAssignDialog = ({ queryOptions, onSuccess }: UseAssignDialogProps) => {
    const { open, close, visible, selected } = useVisible();

    const dialog = useMemo(() => {
        return (
            <AssignDialog
                key={(selected as any)?.id}
                visible={visible}
                close={close}
                request={selected}
                queryOptions={queryOptions}
                onSuccess={onSuccess}
            />
        );
    }, [close, onSuccess, queryOptions, selected, visible]);

    return { open, dialog };
};
